import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table} from 'semantic-ui-react';
import './summary.scss';

class SummarySetsOrders extends Component {
  renderTableInformation() {
    const {summaryList} = this.props;

    if (!summaryList.length) {
      return (
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={3}>
            No hay pedidos en el periodo de tiempo seleccionado
          </Table.Cell>
        </Table.Row>
      );
    }

    return summaryList.map((order, index) => {
      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell>{order.modelName}</Table.Cell>
          <Table.Cell>{order.comboCode}</Table.Cell>
          <Table.Cell>{order.totalVehicles}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {loading, summaryList} = this.props;
    if (loading || !summaryList || !summaryList.length) {
      return null;
    }

    return (
      <Card raised fluid>
        <Table striped className='summary-sets-orders scrollable-body'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell>Modelo</Table.HeaderCell>
              <Table.HeaderCell>Código del Combo</Table.HeaderCell>
              <Table.HeaderCell>
                Número de Combos (<strong>{summaryList.reduce((prev, curr) => {
                  return prev + curr.totalVehicles;
                }, 0)}</strong>)
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderTableInformation()}</Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.setsOrders.loading,
    'summaryList': state.setsOrders.list,
  };
};

export default connect(mapStateToProps)(SummarySetsOrders);
